import { render, staticRenderFns } from "./AddAssetCard.vue?vue&type=template&id=6d4a7874&scoped=true&"
import script from "./AddAssetCard.vue?vue&type=script&lang=ts&"
export * from "./AddAssetCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddAssetCard.vue?vue&type=style&index=0&id=6d4a7874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a7874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCol,VContainer,VIcon})
